import { render } from "./RegisterClientExternal.vue?vue&type=template&id=1cc6e90f"
import script from "./RegisterClientExternal.vue?vue&type=script&lang=js"
export * from "./RegisterClientExternal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__